export class ApprovalDetails {
  approvalName: any;
  description: any;
  approvalDate: any;
  savetype: any;
  createdDate: any;
  modifiedDate: any;
  userId: any;
  centralUserId: any;
  financialPeriodsID: any;
  DescriptionForDormantCompanies:any

  constructor(init?: Partial<ApprovalDetails>) {
    Object.assign(this, init);
  }
}

